import {DEFAULT_FONT} from "./designer.constant";
import {DEFAULT_COLOR, DEFAULT_SHADOW_COLOR, DEFAULT_STROKE_COLOR} from "./color.constant";

export const SAVE_QUOTE_TIME_DELAY = 1000;
export const DATA_LIMIT = 40;

export const DEFAULT_SETTINGS = {
    fontSize: DEFAULT_FONT.fontSize,
    fontFamily: DEFAULT_FONT.fontFamily,
    colorKey: DEFAULT_COLOR.colorKey,
    colorCodeKey: DEFAULT_COLOR.colorCodeKey,
    hexCode: DEFAULT_COLOR.hexCode,
    width: 600,
    height: 600,
    strokeWidth: 3,
    stroke: DEFAULT_STROKE_COLOR.hexCode,
    strokeColorKey: DEFAULT_STROKE_COLOR.colorKey,
    strokeColorCodeKey: DEFAULT_STROKE_COLOR.colorCodeKey,
    fillAfterStrokeEnabled: true,
    lineJoin: 'round', // 'miter','bevel','round'
    shadowColor: DEFAULT_SHADOW_COLOR.hexCode,
    shadowColorKey: DEFAULT_SHADOW_COLOR.colorKey,
    shadowColorCodeKey: DEFAULT_SHADOW_COLOR.colorCodeKey,
    shadowOffsetX: 2,
    shadowOffsetY: 2,
    shadowBlur: 0,
};

export const EDITOR_TABS_LIST = [
    {key: 'text', label: 'Text'},
    {key: 'image', label: 'Image'},
];

export const DEFAULT_EDITOR_TAB = 'text';

